export class CommonConstants {
    public static STAGING = 'staging';
    public static PRODUCTION = 'production';
}
